import React from "react";
import { Link } from "react-router-dom";
import NotFound from "./NotFound";
import Breadcrumbs from "../components/Breadcrumbs";
import JsonLd from "../components/JsonLd";
import { buildBreadcrumbListJsonLd } from "../utils/breadcrumbSchema";
import { absoluteUrl } from "../seo/siteUrl";
import { localLandingPages } from "../constants/localSeoLandings";
import "./LocalLandingPage.css";

function buildArticleJsonLd({ slug, title, metaDescription }) {
  const url = absoluteUrl(`/${slug}`);
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: title,
    description: metaDescription,
    author: {
      "@type": "Organization",
      name: "Panthi Events",
    },
    publisher: {
      "@type": "Organization",
      name: "Panthi Events",
    },
    mainEntityOfPage: url,
  };
}

const LocalLandingPage = ({ slug }) => {
  const data = localLandingPages[slug];
  if (!data) return <NotFound />;

  const path = `/${slug}`;
  const breadcrumbLd = buildBreadcrumbListJsonLd([
    { name: "Home", path: "/" },
    { name: data.h1, path },
  ]);
  const articleLd = buildArticleJsonLd({
    slug,
    title: data.title,
    metaDescription: data.metaDescription,
  });

  return (
    <div className="local-landing-page">
      <JsonLd data={breadcrumbLd} />
      <JsonLd data={articleLd} />

      <Breadcrumbs
        items={[
          { label: "Home", to: "/" },
          { label: data.h1 },
        ]}
      />

      <section className="local-landing-hero">
        <div className="local-landing-container">
          <h1 className="local-landing-h1">{data.h1}</h1>
          <p className="local-landing-intro">{data.intro}</p>
        </div>
      </section>

      <article className="local-landing-body">
        <div className="local-landing-container">
          {data.sections.map((sec, i) => (
            <section key={i} className="local-landing-section">
              <h2 className="local-landing-h2">{sec.h2}</h2>
              {sec.paragraphs.map((p, j) => (
                <p
                  key={j}
                  className="local-landing-p"
                  dangerouslySetInnerHTML={{ __html: p }}
                />
              ))}
            </section>
          ))}

          <nav className="local-landing-internal" aria-label="Related pages">
            <h2 className="local-landing-h2">Explore more</h2>
            <ul className="local-landing-internal-list">
              <li>
                <Link to="/wedding-events">Wedding events</Link>
              </li>
              <li>
                <Link to="/corporate-events">Corporate events</Link>
              </li>
              <li>
                <Link to="/production">Production</Link>
              </li>
              <li>
                <Link to="/blogs">Blogs</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </nav>
        </div>
      </article>
    </div>
  );
};

export default LocalLandingPage;
